<template>
  <v-row>
    <v-data-table :headers="headers" :items="activities" :page.sync="page"
                  :items-per-page="itemsPerPage" sort-by="date" :sort-desc="true"
                  @page-count="pageCount = $event">

      <template v-slot:item.date="{ item }">
        <span>{{ item.date |formatDateTime }} </span>
      </template>

      <template v-slot:item.reservation="{ item }">
        <span>{{ item.reservation.prenom }} {{ item.reservation.nom }} ({{ item.reservation.email }})


        </span>
      </template>

      <template v-slot:item.units="{ item }">
        <div v-for="(unit,i) in item.units" :key="i">{{ unit.prenom }} {{ unit.nom }} ({{ unit.email }})
          <a v-if="unit.file" target="_blank" :href="'/app/api/file?fileId='+ unit.file.id">
            <v-icon class="mr-2" style="color:darkgreen">mdi-download</v-icon>
          </a>
        </div>
      </template>

      <template v-slot:item.prix="{ item }">
        <span>{{ (item.activityType.montantPerUnit * item.units.length) | currency }} </span>
      </template>

      <template v-slot:item.created="{ item }">
        <span>{{ item.created |formatDateTime }} </span>
      </template>

      <template v-slot:item.action="{ item }" v-if="loggedUser.isSuperAdmin">
        <span><v-btn class="mx-2" fab dark small color="error"
                     v-on:click="deleteRecord(item)">
                     <v-icon dark>mdi-delete</v-icon>
                </v-btn>
        </span>
      </template>

    </v-data-table>
    <Confirm ref="confirm"/>
  </v-row>

</template>

<script>


import { ActivitiesApi } from '../../../shared/services/api/activities'
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  name: 'Activities',
  data () {
    return {
      isLoading: true,
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      dateFormat: 'DD-MM-YYYY HH:mm',
      headers: [
        { text: 'N°', align: 'start', sortable: true, value: 'id' },
        { text: 'Activity', align: 'start', sortable: true, value: 'activityType.name' },
        { text: 'Date', sortable: true, value: 'date' },
        { text: 'NombrePerson', sortable: true, value: 'nombrePersonTotal' },
        { text: 'Reservation', sortable: true, value: 'reservation' },
        { text: 'Units', sortable: true, value: 'units' },
        { text: 'Created', sortable: true, value: 'created' },
        { text: 'Prix', sortable: true, value: 'prix' },
        { text: 'Action', value: 'action' }

      ],
      activities: []
    }
  }, mounted () {
    this.reload()
  },
  methods: {
    async deleteRecord (item) {
      if (await this.$refs.confirm.open("Confirm", "Are you sure you want to delete this record? '" + item.id + "'")) {
        this.deleteRecordEffective(item);
      }
    },
    deleteRecordEffective (item) {
      ActivitiesApi.deleteActivity(item.id)
          .then(this.reload())
          .catch(error => this.error = error)
          .finally(() => this.isLoading = false)
    },
    reload () {
      ActivitiesApi.getAllActivities()
          .then(objets => this.activities = objets)
          .catch(error => this.error = error)
          .finally(() => this.isLoading = false)
    }
  },
  computed: {
    bodySlots: function () {
      //Filters the slots of type BODY
      var data = this.activities.filter(slot => slot.field === 'units')
      console.log('data filter', data)
      return data
    },
      ...mapGetters({ loggedUser: 'main/loggedUser' })

  }
}

</script>
